import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { feedbackEntities, feedbackStatuses } from './feedback.types';

export const feedbackFiltersSchema = z
  .object({
    status: z.array(z.enum(feedbackStatuses)).catch([]),
    entity: z.array(z.enum(feedbackEntities)).catch([]),
    entityIds: z.array(z.string()).catch([]),
    employees: z.array(z.string()).catch([]),
    search: z.string().catch(''),
    date: dateRangeSchema,
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
